<div class="background bg-secondary h-100 d-flex align-items-center w-100">
  <div class="container-flex w-100">
    <div class="row d-flex justify-content-center m-0 p-0 w-100">
      <div class="col col-12 col-md-6 col-lg-4 pt-5 pb-5">
        <div class="card p-5 pb-2 pt-4 bg-white">
          <img src="../../../../../../assets/logo.png" class="logo m-auto">
          <h3 class="login fw-semibold mt-4 text-primary text-center">Register</h3>
          <!-- <div class="login">Please enter your login credentials</div> -->
          <div class="d-flex justify-content-center">
            <hr class="" style="border: 2px solid #AA9664; width: 80px;">
          </div>
          <form class="row row-cols-1" [formGroup]="profile" (ngSubmit)="saveProfile()">

            <div class="col my-3">
              <label class="form-label" for="password-input">Your role</label>
              <select id="desiredRole-input" formControlName="desired_role" class="form-select" [ngClass]="{
              'is-invalid': profile.get('desired_role')?.touched && profile.get('desired_role')?.invalid
            }">
                <option value="" disabled selected>Select a role</option>
                @for (role of availableRoles; track role) {
                  <option [ngValue]="role">{{ role }}</option>
                }
              </select>
              @if (profile.get('desired_role')?.touched && profile.get('desired_role')?.invalid) {
                <div
                  class="invalid-feedback">
                  @if (profile.get('desired_role')?.hasError('required')) {
                    <div>Role is required.</div>
                  }
                  @if (profile.get('desired_role')?.hasError('invalidRole')) {
                    <div>
                      The selected role is not valid.
                    </div>
                  }
                </div>
              }
            </div>

            <div class="col my-3">
              <label class="form-label" for="username-input">Username</label>
              <input id="username-input" type="text" formControlName="username" class="form-control"
                [ngClass]="{'is-invalid': profile.get('username')?.touched && profile.get('username')?.invalid}">
                @if (profile.get('username')?.touched && profile.get('username')?.invalid) {
                  <div
                    class="invalid-feedback">
                    @if (profile.get('username')?.hasError('required')) {
                      <div>Username is required.</div>
                    }
                    @if (profile.get('username')?.hasError('minlength')) {
                      <div>Username must be at least 3 characters long.
                      </div>
                    }
                    @if (profile.get('username')?.hasError('maxlength')) {
                      <div>Username cannot exceed 20 characters.</div>
                    }
                  </div>
                }
              </div>

              <div class="col my-3">
                <label class="form-label" for="name-input">First name</label>
                <input id="name-input" type="text" formControlName="firstname" class="form-control"
                  [ngClass]="{'is-invalid': profile.get('firstname')?.touched && profile.get('firstname')?.invalid}">
                  @if (profile.get('firstname')?.touched && profile.get('firstname')?.invalid) {
                    <div
                      class="invalid-feedback">
                      @if (profile.get('firstname')?.hasError('required')) {
                        <div>First name is required.</div>
                      }
                      @if (profile.get('firstname')?.hasError('minlength')) {
                        <div>First name must be at least 2 characters
                        long.</div>
                      }
                      @if (profile.get('firstname')?.hasError('maxlength')) {
                        <div>First name cannot exceed 30 characters.
                        </div>
                      }
                    </div>
                  }
                </div>

                <div class="col my-3">
                  <label class="form-label" for="lastname-input">Last name</label>
                  <input id="lastname-input" type="text" formControlName="lastname" class="form-control"
                    [ngClass]="{'is-invalid': profile.get('lastname')?.touched && profile.get('lastname')?.invalid}">
                    @if (profile.get('lastname')?.touched && profile.get('lastname')?.invalid) {
                      <div
                        class="invalid-feedback">
                        @if (profile.get('lastname')?.hasError('required')) {
                          <div>Last name is required.</div>
                        }
                        @if (profile.get('lastname')?.hasError('minlength')) {
                          <div>Last name must be at least 2 characters
                          long.</div>
                        }
                        @if (profile.get('lastname')?.hasError('maxlength')) {
                          <div>Last name cannot exceed 30 characters.</div>
                        }
                      </div>
                    }
                  </div>

                  <div class="col my-3">
                    <label class="form-label" for="email-input">Email</label>
                    <input id="email-input" type="text" formControlName="email" class="form-control"
                      [ngClass]="{'is-invalid': profile.get('email')?.touched && profile.get('email')?.invalid}">
                      @if (profile.get('email')?.touched && profile.get('email')?.invalid) {
                        <div class="invalid-feedback">
                          @if (profile.get('email')?.hasError('required')) {
                            <div>Email is required.</div>
                          }
                          @if (profile.get('email')?.hasError('email')) {
                            <div>Email is not valid.</div>
                          }
                        </div>
                      }
                    </div>

                    <div class="col my-3">
                      <label class="form-label" for="walletAddress-input">Wallet address</label>
                      <!-- <input id="walletAddress-input" type="text" formControlName="wallet_address" class="form-control"
                      [ngClass]="{'is-invalid': profile.get('wallet_address')?.touched && profile.get('wallet_address')?.invalid}">
                      <div *ngIf="profile.get('wallet_address')?.touched && profile.get('wallet_address')?.invalid"
                        class="invalid-feedback">
                        <div *ngIf="profile.get('wallet_address')?.hasError('required')">Wallet address is required.</div>
                        <div *ngIf="profile.get('wallet_address')?.hasError('pattern')">Wallet address is not valid.</div>
                      </div> -->

                      @if(profile.get('wallet_address')?.value){

                        <app-qr-generator class="w-100 input-group" [btnPxWidth]="'50px'"
                          [qrText]="profile.get('wallet_address')?.value"
                          [btnClasses]="'btn-primary rounded-end-3 px-0 d-flex justify-content-center'">

                          <input id="wallet" type="text" class="form-control" placeholder="0x..."
                            [value]="profile.get('wallet_address')?.value">

                          </app-qr-generator>

                        }

                        @if(!profile.get('wallet_address')?.value){

                          <app-qr-scanner (scanResult)="onScanResult($event)" class="w-100 input-group">
                            <input type="text" class="form-control shadow-none" placeholder="0x..."
                              formControlName="wallet_address">
                              <!-- [value]="profile.get('wallet_address')?.value"> -->
                              <!-- form-control-lg bg-white border-secondary border-2 -->
                              <!-- {{ t('modals.transfer.texts.toPlaceholder') }} -->
                            </app-qr-scanner>

                          }


                        </div>

                        <div class="col my-3">
                          <label class="form-label" for="password-input">Password</label>
              <app-input-password formControlName="password" [ngClass]="{
                'is-invalid': profile.get('password')?.touched && profile.get('password')?.invalid
              }"></app-input-password>
                          @if (profile.get('password')?.touched && profile.get('password')?.invalid) {
                            <div
                              class="invalid-feedback">
                              @if (profile.get('password')?.hasError('passwordInvalid')) {
                                <div>
                                  Password must be at least 6 characters long, include uppercase, lowercase letters, and at least one
                                  number.
                                </div>
                              }
                              @if (profile.get('password')?.hasError('required')) {
                                <div>Password is required.</div>
                              }
                            </div>
                          }
                        </div>

                        <div class="col my-3 d-flex justify-content-center">
                          <button type="submit" class="btn btn-primary"> Save </button>
                        </div>

                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
